import {
  Box,
  Button,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor42,
  greyColor53,
  greyColor54,
  greyColor56,
  lightGreen04,
  lightgreenColor04,
  lightOrange05,
  lightOrange06,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { toTitleCase } from "../../../utils/validationUtils";
import ModalCard from "../../../components/ModalCard";
import AllSaleByAreaReport from "../Cards/AllSaleByAreaReport";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../../../configs/Constants";
import CityDrillDownTable from "./CityDrillDownTable";

const mapContainerStyle = {
  width: "100%",
  height: "250px",
  borderRadius: "10px",
  border: "1px solid" + greyColor53,
};

function SalesByAreaSection({
  orderReportByCity,
  allBranchIds,
  getBrandNameById,
  masterBranchInfo,
}) {
  const [viewMore, setViewMore] = useState(false);

  const [showDrillDown, setShowDrillDown] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleCityClick = (data) => {
    console.log("CITY___CLIKCED", data);
    
    setSelectedData(data);
    setShowDrillDown(true);
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY, // Replace with your API key
  });

  const [mapCenter, setMapCenter] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(4.83); // Dynamic zoom
  const [bounds, setBounds] = useState(null);

  // function to calculate zoom dynamically
  const calculateZoom = (bounds) => {
    const WORLD_DIM = { width: 256, height: 256 };
    const ZOOM_MAX = 21;

    const latDiff = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();
    const lngDiff = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();

    const latZoom = Math.log2(WORLD_DIM.height / latDiff);
    const lngZoom = Math.log2(WORLD_DIM.width / lngDiff);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
  };

  useEffect(() => {
    if (orderReportByCity?.length > 0 && isLoaded) {
      const bounds = new window.google.maps.LatLngBounds();
      orderReportByCity?.slice(0, 5).forEach((area) => {
        bounds.extend({
          lat: area.lat,
          lng: area.lng,
        });
      });

      setMapCenter(bounds.getCenter().toJSON());
      const zoom = calculateZoom(bounds);
      setCurrentZoom(zoom > 20 ? 10 : zoom + 0.1);
      setTimeout(() => {
        setCurrentZoom(zoom > 20 ? 10 : zoom + 0.101);
      }, 800);
      setBounds(bounds);
    }
  }, [isLoaded, orderReportByCity]);

  return (
    <>
      <Stack
        sx={{
          border: "1px solid " + greyColor56,
          borderRadius: "12px",
          overflow: "hidden",
          minHeight: "100%",
          p: "10px 14px",
          gap: 2,
        }}
        minHeight={"100%"}
      >
        <ModalCard
          open={viewMore}
          handleClose={() => setViewMore(false)}
          width="50%"
        >
          <AllSaleByAreaReport orderReportByCity={orderReportByCity} />
        </ModalCard>

        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            fontSize={13.5}
            fontWeight={600}
            color={blackShade19}
            lineHeight="20px"
          >
            Sales by Area
          </Typography>
          {orderReportByCity?.length > 3 && (
            <Typography
              fontSize={11}
              fontWeight={500}
              color={blueColor04}
              component={Button}
              lineHeight={1.5}
              sx={{
                textDecoration: "underline",
                textTransform: "none",
                p: "0px",
                "&:hover": { background: "transparent" },
              }}
              onClick={() => setViewMore(true)}
            >
              View More
            </Typography>
          )}
        </Box>

        <Grid container columnSpacing={2}>
          <Grid item xs={12} md={7}>
            {isLoaded ? (
              <GoogleMapView
                mapContainerStyle={mapContainerStyle}
                currentZoom={currentZoom}
                mapCenter={mapCenter}
                data={orderReportByCity?.slice(0, 5)}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Loading Map...
              </Box>
            )}
          </Grid>
          <Grid item xs={12} md={5}>
            <Box sx={styles.tableWrapper}>
              <TableContainer sx={styles.tableContainer} component={Box}>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        position: "sticky !important",
                        top: 0,
                        backgroundColor: greyColor53,
                        zIndex: 7,
                      }}
                    >
                      <TableCell
                        sx={{ ...styles.tableCell, width: "80%" }}
                        align="center"
                      >
                        City, State
                      </TableCell>
                      <TableCell sx={styles.tableCell} align="center">
                        Orders
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: whiteColor }}>
                    {orderReportByCity?.slice(0, 5)?.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          borderBottom: `1px solid ${borderTextBoxColor}`,
                          verticalAlign: "top",
                          cursor:'pointer',
                          '&:hover':{
                            bgcolor: lightGreen04
                          }
                        }}
                        onClick={()=>handleCityClick(item?.cityState)}
                      >
                        <TableCell
                          sx={{ ...styles.tableBodyCell, maxWidth: "80%" }}
                        >
                          <Box display="flex" gap="8px">
                            <Box
                              component="img"
                              src="/./assets/image/location-icon.svg"
                              sx={{
                                width: "20px",
                                height: "auto",
                              }}
                            />
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: 11.5,
                                  fontWeight: 600,
                                  color: blackShade19,
                                  lineHeight: "16px",
                                }}
                              >
                                {toTitleCase(item?.cityState?.city)},{" "}
                                {toTitleCase(item?.cityState?.state)}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: 400,
                                  color: greyColor060,
                                  lineHeight: "16px",
                                }}
                              >
                                {/* 530068 */}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell sx={styles.tableBodyCell}>
                          <Box
                            sx={{
                              fontWeight: 600,
                              fontSize: "12px",
                              color: greenStatusColor01,
                              textAlign: "center",
                            }}
                          >
                            {item?.orderCount}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Stack>

      {showDrillDown && (
        <CityDrillDownTable
          selectedData={selectedData}
          allBranchIds={allBranchIds}
          open={showDrillDown}
          setOpen={setShowDrillDown}
          drillDownType="year"
          getBrandNameById={getBrandNameById}
          masterBranchInfo={masterBranchInfo}
        />
      )}
    </>
  );
}

export default SalesByAreaSection;

const GoogleMapView = ({ mapContainerStyle, currentZoom, mapCenter, data }) => {
  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={currentZoom}
      center={mapCenter}
      options={{
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      }}
    >
      {data?.map((area, index) => {
        return (
          <Marker
            // onClick={() => onMarkerClick(branch)}
            key={index}
            position={{
              lat: area?.lat,
              lng: area?.lng,
            }}
            title={area?.cityState?.city}
            // title={area?.cityState?.cityState}
            icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
              scaledSize: new window.google.maps.Size(30, 30),
            }}
          />
        );
      })}
    </GoogleMap>
  );
};

const styles = {
  tableWrapper: {
    width: "100%",
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
    borderBottom: "none",
    overflow: "hidden",
  },

  tableContainer: {
    borderRadius: "8px",
    maxWidth: "100%",
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },
};
